const followers = [
  {
    login: 'sunny',
    id: 132,
    node_id: 'MDQ6VXNlcjEzMg==',
    avatar_url: 'https://avatars.githubusercontent.com/u/132?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/sunny',
    html_url: 'https://github.com/sunny',
    followers_url: 'https://api.github.com/users/sunny/followers',
    following_url: 'https://api.github.com/users/sunny/following{/other_user}',
    gists_url: 'https://api.github.com/users/sunny/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/sunny/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/sunny/subscriptions',
    organizations_url: 'https://api.github.com/users/sunny/orgs',
    repos_url: 'https://api.github.com/users/sunny/repos',
    events_url: 'https://api.github.com/users/sunny/events{/privacy}',
    received_events_url: 'https://api.github.com/users/sunny/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'rbazinet',
    id: 170,
    node_id: 'MDQ6VXNlcjE3MA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/170?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/rbazinet',
    html_url: 'https://github.com/rbazinet',
    followers_url: 'https://api.github.com/users/rbazinet/followers',
    following_url: 'https://api.github.com/users/rbazinet/following{/other_user}',
    gists_url: 'https://api.github.com/users/rbazinet/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/rbazinet/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/rbazinet/subscriptions',
    organizations_url: 'https://api.github.com/users/rbazinet/orgs',
    repos_url: 'https://api.github.com/users/rbazinet/repos',
    events_url: 'https://api.github.com/users/rbazinet/events{/privacy}',
    received_events_url: 'https://api.github.com/users/rbazinet/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'croaky',
    id: 198,
    node_id: 'MDQ6VXNlcjE5OA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/198?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/croaky',
    html_url: 'https://github.com/croaky',
    followers_url: 'https://api.github.com/users/croaky/followers',
    following_url: 'https://api.github.com/users/croaky/following{/other_user}',
    gists_url: 'https://api.github.com/users/croaky/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/croaky/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/croaky/subscriptions',
    organizations_url: 'https://api.github.com/users/croaky/orgs',
    repos_url: 'https://api.github.com/users/croaky/repos',
    events_url: 'https://api.github.com/users/croaky/events{/privacy}',
    received_events_url: 'https://api.github.com/users/croaky/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'tkersey',
    id: 217,
    node_id: 'MDQ6VXNlcjIxNw==',
    avatar_url: 'https://avatars.githubusercontent.com/u/217?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/tkersey',
    html_url: 'https://github.com/tkersey',
    followers_url: 'https://api.github.com/users/tkersey/followers',
    following_url: 'https://api.github.com/users/tkersey/following{/other_user}',
    gists_url: 'https://api.github.com/users/tkersey/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/tkersey/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/tkersey/subscriptions',
    organizations_url: 'https://api.github.com/users/tkersey/orgs',
    repos_url: 'https://api.github.com/users/tkersey/repos',
    events_url: 'https://api.github.com/users/tkersey/events{/privacy}',
    received_events_url: 'https://api.github.com/users/tkersey/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'ambethia',
    id: 298,
    node_id: 'MDQ6VXNlcjI5OA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/298?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/ambethia',
    html_url: 'https://github.com/ambethia',
    followers_url: 'https://api.github.com/users/ambethia/followers',
    following_url: 'https://api.github.com/users/ambethia/following{/other_user}',
    gists_url: 'https://api.github.com/users/ambethia/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/ambethia/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/ambethia/subscriptions',
    organizations_url: 'https://api.github.com/users/ambethia/orgs',
    repos_url: 'https://api.github.com/users/ambethia/repos',
    events_url: 'https://api.github.com/users/ambethia/events{/privacy}',
    received_events_url: 'https://api.github.com/users/ambethia/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'sco',
    id: 306,
    node_id: 'MDQ6VXNlcjMwNg==',
    avatar_url: 'https://avatars.githubusercontent.com/u/306?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/sco',
    html_url: 'https://github.com/sco',
    followers_url: 'https://api.github.com/users/sco/followers',
    following_url: 'https://api.github.com/users/sco/following{/other_user}',
    gists_url: 'https://api.github.com/users/sco/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/sco/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/sco/subscriptions',
    organizations_url: 'https://api.github.com/users/sco/orgs',
    repos_url: 'https://api.github.com/users/sco/repos',
    events_url: 'https://api.github.com/users/sco/events{/privacy}',
    received_events_url: 'https://api.github.com/users/sco/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'vic',
    id: 331,
    node_id: 'MDQ6VXNlcjMzMQ==',
    avatar_url: 'https://avatars.githubusercontent.com/u/331?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/vic',
    html_url: 'https://github.com/vic',
    followers_url: 'https://api.github.com/users/vic/followers',
    following_url: 'https://api.github.com/users/vic/following{/other_user}',
    gists_url: 'https://api.github.com/users/vic/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/vic/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/vic/subscriptions',
    organizations_url: 'https://api.github.com/users/vic/orgs',
    repos_url: 'https://api.github.com/users/vic/repos',
    events_url: 'https://api.github.com/users/vic/events{/privacy}',
    received_events_url: 'https://api.github.com/users/vic/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'choonkeat',
    id: 473,
    node_id: 'MDQ6VXNlcjQ3Mw==',
    avatar_url: 'https://avatars.githubusercontent.com/u/473?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/choonkeat',
    html_url: 'https://github.com/choonkeat',
    followers_url: 'https://api.github.com/users/choonkeat/followers',
    following_url: 'https://api.github.com/users/choonkeat/following{/other_user}',
    gists_url: 'https://api.github.com/users/choonkeat/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/choonkeat/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/choonkeat/subscriptions',
    organizations_url: 'https://api.github.com/users/choonkeat/orgs',
    repos_url: 'https://api.github.com/users/choonkeat/repos',
    events_url: 'https://api.github.com/users/choonkeat/events{/privacy}',
    received_events_url: 'https://api.github.com/users/choonkeat/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'kjf',
    id: 498,
    node_id: 'MDQ6VXNlcjQ5OA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/498?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/kjf',
    html_url: 'https://github.com/kjf',
    followers_url: 'https://api.github.com/users/kjf/followers',
    following_url: 'https://api.github.com/users/kjf/following{/other_user}',
    gists_url: 'https://api.github.com/users/kjf/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/kjf/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/kjf/subscriptions',
    organizations_url: 'https://api.github.com/users/kjf/orgs',
    repos_url: 'https://api.github.com/users/kjf/repos',
    events_url: 'https://api.github.com/users/kjf/events{/privacy}',
    received_events_url: 'https://api.github.com/users/kjf/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'kad3nce',
    id: 556,
    node_id: 'MDQ6VXNlcjU1Ng==',
    avatar_url: 'https://avatars.githubusercontent.com/u/556?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/kad3nce',
    html_url: 'https://github.com/kad3nce',
    followers_url: 'https://api.github.com/users/kad3nce/followers',
    following_url: 'https://api.github.com/users/kad3nce/following{/other_user}',
    gists_url: 'https://api.github.com/users/kad3nce/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/kad3nce/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/kad3nce/subscriptions',
    organizations_url: 'https://api.github.com/users/kad3nce/orgs',
    repos_url: 'https://api.github.com/users/kad3nce/repos',
    events_url: 'https://api.github.com/users/kad3nce/events{/privacy}',
    received_events_url: 'https://api.github.com/users/kad3nce/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'chrislloyd',
    id: 718,
    node_id: 'MDQ6VXNlcjcxOA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/718?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/chrislloyd',
    html_url: 'https://github.com/chrislloyd',
    followers_url: 'https://api.github.com/users/chrislloyd/followers',
    following_url: 'https://api.github.com/users/chrislloyd/following{/other_user}',
    gists_url: 'https://api.github.com/users/chrislloyd/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/chrislloyd/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/chrislloyd/subscriptions',
    organizations_url: 'https://api.github.com/users/chrislloyd/orgs',
    repos_url: 'https://api.github.com/users/chrislloyd/repos',
    events_url: 'https://api.github.com/users/chrislloyd/events{/privacy}',
    received_events_url: 'https://api.github.com/users/chrislloyd/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'pjb3',
    id: 726,
    node_id: 'MDQ6VXNlcjcyNg==',
    avatar_url: 'https://avatars.githubusercontent.com/u/726?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/pjb3',
    html_url: 'https://github.com/pjb3',
    followers_url: 'https://api.github.com/users/pjb3/followers',
    following_url: 'https://api.github.com/users/pjb3/following{/other_user}',
    gists_url: 'https://api.github.com/users/pjb3/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/pjb3/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/pjb3/subscriptions',
    organizations_url: 'https://api.github.com/users/pjb3/orgs',
    repos_url: 'https://api.github.com/users/pjb3/repos',
    events_url: 'https://api.github.com/users/pjb3/events{/privacy}',
    received_events_url: 'https://api.github.com/users/pjb3/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'vigosan',
    id: 767,
    node_id: 'MDQ6VXNlcjc2Nw==',
    avatar_url: 'https://avatars.githubusercontent.com/u/767?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/vigosan',
    html_url: 'https://github.com/vigosan',
    followers_url: 'https://api.github.com/users/vigosan/followers',
    following_url: 'https://api.github.com/users/vigosan/following{/other_user}',
    gists_url: 'https://api.github.com/users/vigosan/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/vigosan/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/vigosan/subscriptions',
    organizations_url: 'https://api.github.com/users/vigosan/orgs',
    repos_url: 'https://api.github.com/users/vigosan/repos',
    events_url: 'https://api.github.com/users/vigosan/events{/privacy}',
    received_events_url: 'https://api.github.com/users/vigosan/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'andypearson',
    id: 857,
    node_id: 'MDQ6VXNlcjg1Nw==',
    avatar_url: 'https://avatars.githubusercontent.com/u/857?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/andypearson',
    html_url: 'https://github.com/andypearson',
    followers_url: 'https://api.github.com/users/andypearson/followers',
    following_url: 'https://api.github.com/users/andypearson/following{/other_user}',
    gists_url: 'https://api.github.com/users/andypearson/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/andypearson/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/andypearson/subscriptions',
    organizations_url: 'https://api.github.com/users/andypearson/orgs',
    repos_url: 'https://api.github.com/users/andypearson/repos',
    events_url: 'https://api.github.com/users/andypearson/events{/privacy}',
    received_events_url: 'https://api.github.com/users/andypearson/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'scotu',
    id: 868,
    node_id: 'MDQ6VXNlcjg2OA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/868?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/scotu',
    html_url: 'https://github.com/scotu',
    followers_url: 'https://api.github.com/users/scotu/followers',
    following_url: 'https://api.github.com/users/scotu/following{/other_user}',
    gists_url: 'https://api.github.com/users/scotu/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/scotu/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/scotu/subscriptions',
    organizations_url: 'https://api.github.com/users/scotu/orgs',
    repos_url: 'https://api.github.com/users/scotu/repos',
    events_url: 'https://api.github.com/users/scotu/events{/privacy}',
    received_events_url: 'https://api.github.com/users/scotu/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'shenoudab',
    id: 911,
    node_id: 'MDQ6VXNlcjkxMQ==',
    avatar_url: 'https://avatars.githubusercontent.com/u/911?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/shenoudab',
    html_url: 'https://github.com/shenoudab',
    followers_url: 'https://api.github.com/users/shenoudab/followers',
    following_url: 'https://api.github.com/users/shenoudab/following{/other_user}',
    gists_url: 'https://api.github.com/users/shenoudab/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/shenoudab/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/shenoudab/subscriptions',
    organizations_url: 'https://api.github.com/users/shenoudab/orgs',
    repos_url: 'https://api.github.com/users/shenoudab/repos',
    events_url: 'https://api.github.com/users/shenoudab/events{/privacy}',
    received_events_url: 'https://api.github.com/users/shenoudab/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'cbartlett',
    id: 925,
    node_id: 'MDQ6VXNlcjkyNQ==',
    avatar_url: 'https://avatars.githubusercontent.com/u/925?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/cbartlett',
    html_url: 'https://github.com/cbartlett',
    followers_url: 'https://api.github.com/users/cbartlett/followers',
    following_url: 'https://api.github.com/users/cbartlett/following{/other_user}',
    gists_url: 'https://api.github.com/users/cbartlett/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/cbartlett/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/cbartlett/subscriptions',
    organizations_url: 'https://api.github.com/users/cbartlett/orgs',
    repos_url: 'https://api.github.com/users/cbartlett/repos',
    events_url: 'https://api.github.com/users/cbartlett/events{/privacy}',
    received_events_url: 'https://api.github.com/users/cbartlett/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'brianleroux',
    id: 990,
    node_id: 'MDQ6VXNlcjk5MA==',
    avatar_url: 'https://avatars.githubusercontent.com/u/990?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/brianleroux',
    html_url: 'https://github.com/brianleroux',
    followers_url: 'https://api.github.com/users/brianleroux/followers',
    following_url: 'https://api.github.com/users/brianleroux/following{/other_user}',
    gists_url: 'https://api.github.com/users/brianleroux/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/brianleroux/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/brianleroux/subscriptions',
    organizations_url: 'https://api.github.com/users/brianleroux/orgs',
    repos_url: 'https://api.github.com/users/brianleroux/repos',
    events_url: 'https://api.github.com/users/brianleroux/events{/privacy}',
    received_events_url: 'https://api.github.com/users/brianleroux/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'andrew',
    id: 1060,
    node_id: 'MDQ6VXNlcjEwNjA=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1060?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/andrew',
    html_url: 'https://github.com/andrew',
    followers_url: 'https://api.github.com/users/andrew/followers',
    following_url: 'https://api.github.com/users/andrew/following{/other_user}',
    gists_url: 'https://api.github.com/users/andrew/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/andrew/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/andrew/subscriptions',
    organizations_url: 'https://api.github.com/users/andrew/orgs',
    repos_url: 'https://api.github.com/users/andrew/repos',
    events_url: 'https://api.github.com/users/andrew/events{/privacy}',
    received_events_url: 'https://api.github.com/users/andrew/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'rapind',
    id: 1202,
    node_id: 'MDQ6VXNlcjEyMDI=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1202?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/rapind',
    html_url: 'https://github.com/rapind',
    followers_url: 'https://api.github.com/users/rapind/followers',
    following_url: 'https://api.github.com/users/rapind/following{/other_user}',
    gists_url: 'https://api.github.com/users/rapind/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/rapind/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/rapind/subscriptions',
    organizations_url: 'https://api.github.com/users/rapind/orgs',
    repos_url: 'https://api.github.com/users/rapind/repos',
    events_url: 'https://api.github.com/users/rapind/events{/privacy}',
    received_events_url: 'https://api.github.com/users/rapind/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'sverrejoh',
    id: 1209,
    node_id: 'MDQ6VXNlcjEyMDk=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1209?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/sverrejoh',
    html_url: 'https://github.com/sverrejoh',
    followers_url: 'https://api.github.com/users/sverrejoh/followers',
    following_url: 'https://api.github.com/users/sverrejoh/following{/other_user}',
    gists_url: 'https://api.github.com/users/sverrejoh/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/sverrejoh/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/sverrejoh/subscriptions',
    organizations_url: 'https://api.github.com/users/sverrejoh/orgs',
    repos_url: 'https://api.github.com/users/sverrejoh/repos',
    events_url: 'https://api.github.com/users/sverrejoh/events{/privacy}',
    received_events_url: 'https://api.github.com/users/sverrejoh/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'csshsh',
    id: 1220,
    node_id: 'MDQ6VXNlcjEyMjA=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1220?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/csshsh',
    html_url: 'https://github.com/csshsh',
    followers_url: 'https://api.github.com/users/csshsh/followers',
    following_url: 'https://api.github.com/users/csshsh/following{/other_user}',
    gists_url: 'https://api.github.com/users/csshsh/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/csshsh/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/csshsh/subscriptions',
    organizations_url: 'https://api.github.com/users/csshsh/orgs',
    repos_url: 'https://api.github.com/users/csshsh/repos',
    events_url: 'https://api.github.com/users/csshsh/events{/privacy}',
    received_events_url: 'https://api.github.com/users/csshsh/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'charlenopires',
    id: 1365,
    node_id: 'MDQ6VXNlcjEzNjU=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1365?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/charlenopires',
    html_url: 'https://github.com/charlenopires',
    followers_url: 'https://api.github.com/users/charlenopires/followers',
    following_url: 'https://api.github.com/users/charlenopires/following{/other_user}',
    gists_url: 'https://api.github.com/users/charlenopires/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/charlenopires/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/charlenopires/subscriptions',
    organizations_url: 'https://api.github.com/users/charlenopires/orgs',
    repos_url: 'https://api.github.com/users/charlenopires/repos',
    events_url: 'https://api.github.com/users/charlenopires/events{/privacy}',
    received_events_url: 'https://api.github.com/users/charlenopires/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'capitalist',
    id: 1639,
    node_id: 'MDQ6VXNlcjE2Mzk=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1639?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/capitalist',
    html_url: 'https://github.com/capitalist',
    followers_url: 'https://api.github.com/users/capitalist/followers',
    following_url: 'https://api.github.com/users/capitalist/following{/other_user}',
    gists_url: 'https://api.github.com/users/capitalist/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/capitalist/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/capitalist/subscriptions',
    organizations_url: 'https://api.github.com/users/capitalist/orgs',
    repos_url: 'https://api.github.com/users/capitalist/repos',
    events_url: 'https://api.github.com/users/capitalist/events{/privacy}',
    received_events_url: 'https://api.github.com/users/capitalist/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'cw',
    id: 1692,
    node_id: 'MDQ6VXNlcjE2OTI=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1692?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/cw',
    html_url: 'https://github.com/cw',
    followers_url: 'https://api.github.com/users/cw/followers',
    following_url: 'https://api.github.com/users/cw/following{/other_user}',
    gists_url: 'https://api.github.com/users/cw/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/cw/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/cw/subscriptions',
    organizations_url: 'https://api.github.com/users/cw/orgs',
    repos_url: 'https://api.github.com/users/cw/repos',
    events_url: 'https://api.github.com/users/cw/events{/privacy}',
    received_events_url: 'https://api.github.com/users/cw/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'jkochis',
    id: 1767,
    node_id: 'MDQ6VXNlcjE3Njc=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1767?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/jkochis',
    html_url: 'https://github.com/jkochis',
    followers_url: 'https://api.github.com/users/jkochis/followers',
    following_url: 'https://api.github.com/users/jkochis/following{/other_user}',
    gists_url: 'https://api.github.com/users/jkochis/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/jkochis/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/jkochis/subscriptions',
    organizations_url: 'https://api.github.com/users/jkochis/orgs',
    repos_url: 'https://api.github.com/users/jkochis/repos',
    events_url: 'https://api.github.com/users/jkochis/events{/privacy}',
    received_events_url: 'https://api.github.com/users/jkochis/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'jakobo',
    id: 1795,
    node_id: 'MDQ6VXNlcjE3OTU=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1795?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/jakobo',
    html_url: 'https://github.com/jakobo',
    followers_url: 'https://api.github.com/users/jakobo/followers',
    following_url: 'https://api.github.com/users/jakobo/following{/other_user}',
    gists_url: 'https://api.github.com/users/jakobo/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/jakobo/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/jakobo/subscriptions',
    organizations_url: 'https://api.github.com/users/jakobo/orgs',
    repos_url: 'https://api.github.com/users/jakobo/repos',
    events_url: 'https://api.github.com/users/jakobo/events{/privacy}',
    received_events_url: 'https://api.github.com/users/jakobo/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'seflless',
    id: 1845,
    node_id: 'MDQ6VXNlcjE4NDU=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1845?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/seflless',
    html_url: 'https://github.com/seflless',
    followers_url: 'https://api.github.com/users/seflless/followers',
    following_url: 'https://api.github.com/users/seflless/following{/other_user}',
    gists_url: 'https://api.github.com/users/seflless/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/seflless/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/seflless/subscriptions',
    organizations_url: 'https://api.github.com/users/seflless/orgs',
    repos_url: 'https://api.github.com/users/seflless/repos',
    events_url: 'https://api.github.com/users/seflless/events{/privacy}',
    received_events_url: 'https://api.github.com/users/seflless/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'PhilAndrew',
    id: 1852,
    node_id: 'MDQ6VXNlcjE4NTI=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1852?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/PhilAndrew',
    html_url: 'https://github.com/PhilAndrew',
    followers_url: 'https://api.github.com/users/PhilAndrew/followers',
    following_url: 'https://api.github.com/users/PhilAndrew/following{/other_user}',
    gists_url: 'https://api.github.com/users/PhilAndrew/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/PhilAndrew/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/PhilAndrew/subscriptions',
    organizations_url: 'https://api.github.com/users/PhilAndrew/orgs',
    repos_url: 'https://api.github.com/users/PhilAndrew/repos',
    events_url: 'https://api.github.com/users/PhilAndrew/events{/privacy}',
    received_events_url: 'https://api.github.com/users/PhilAndrew/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'thetoine',
    id: 1877,
    node_id: 'MDQ6VXNlcjE4Nzc=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1877?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/thetoine',
    html_url: 'https://github.com/thetoine',
    followers_url: 'https://api.github.com/users/thetoine/followers',
    following_url: 'https://api.github.com/users/thetoine/following{/other_user}',
    gists_url: 'https://api.github.com/users/thetoine/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/thetoine/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/thetoine/subscriptions',
    organizations_url: 'https://api.github.com/users/thetoine/orgs',
    repos_url: 'https://api.github.com/users/thetoine/repos',
    events_url: 'https://api.github.com/users/thetoine/events{/privacy}',
    received_events_url: 'https://api.github.com/users/thetoine/received_events',
    type: 'User',
    site_admin: false,
  },
];

export default followers;
